<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-alert type="info" show :info="'Berikut daftar Jenis Kelas dalam Seri <strong>' + current_instansi.nama + '</strong>. '">
          <template v-slot:default>
            <m-button class="mt-n1 mx-0" small textButton="Tambah Jenis" action="add" @add="add()"></m-button>
          </template>
        </m-alert>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="item in items" :key="item.id">
            <ClassTypeCard :title="item.keterangan" :item="item" :actions="more_menu" @syarat="openDlg(item)" />
          </v-col>
        </v-row>
      </v-col>
      <ChangeDlg ref="dlg" />
      <SyaratDlg ref="dlgSyarat" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO, PASSPORT } from "@/const";
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import SyaratDlg from "../components/FormSyarat.vue";
import ClassTypeCard from "@/components/ClassTypeCard";

//@group Jenis Kelas
export default {
  name: "jenis-kelas-list",
  components: {
    ChangeDlg,
    SyaratDlg,
    ClassTypeCard
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      icon: "mdi-eye",
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o)
        }
      ],
      syarat: { click: o => this.addSyarat(o) }
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    },
    //@vuese
    //pengecekan apakah memiliki akses kelola kelas (CRUD kelas)
    addData() {
      return isCan("kelas");
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    //@vuese
    //kembali ke halaman kelola seri
    toDashboard() {
      this.$router.push({ name: "instansi.pilih.admin" });
    },
    //@vuese
    //menampilkan daftar jenis kelas sesuai instansi aktif dan parameter yang digunakan
    load() {
      var params = {
        page: this.cp,
        peran: this.peran
      };
      if (this.dataPencarian) {
        params[this.dataPencarian.param] = this.dataPencarian.s;
      }
      return this.$store
        .dispatch("jenisKelas/get", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    //@vuese
    //tampilkan form input jenis kelas
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    //@vuese
    //tampilkan form edit jenis kelas
    // @args objek jenis kelas
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //hapus jenis kelas
    // @args objek jenis kelas
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus jenis kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.keterangan}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("jenisKelas/drop", item))
        .then(() => {
          this.$info("Jenis Kelas " + item.keterangan + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //Membuka dialog tambah syarat
    //@objek syarat pendaftaran
    openDlg(item) {
      this.$refs.dlgSyarat.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //menuju link lms
    // @args objek kelas
    toCourse(val) {
      window.open(PASSPORT + val.link_learndash, "_blank");
    }
  },
  watch: {
    instansi_id() {
      this.load();
      this;
    }
  }
};
</script>
